__turbopack_context__.v({
  "--flow-grid": "photo-gallery-ad-module-scss-module__aC8Qea__--flow-grid",
  "--flow-masonry": "photo-gallery-ad-module-scss-module__aC8Qea__--flow-masonry",
  "--scroll": "photo-gallery-ad-module-scss-module__aC8Qea__--scroll",
  "photo-gallery-ad": "photo-gallery-ad-module-scss-module__aC8Qea__photo-gallery-ad",
});
